"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultPillIconSize = exports.disabledProp = exports.readOnlyProp = exports.errorProp = exports.regularProp = exports.classes = void 0;
var classes = {
  container: 'bds-pill-container',
  bgDarkColor: 'bds-pill-dark-color',
  bgLightColor: 'bds-pill-light-color',
  label: 'bds-pill-label',
  readOnlyPillLabel: 'bds-pill-label-read-only',
  disabledPillLabel: 'bds-pill-label-disabled',
  icon: 'bds-pill-icon',
  regularPill: 'bds-regular-pill',
  errorPill: 'bds-error-pill',
  disabledPill: 'bds-disabled-pill',
  readOnlyPill: 'bds-read-only-pill',
  disabledPillIcon: 'bds-pill-icon-disabled',
  pillIconContainer: 'bds-pill-icon-container'
};
exports.classes = classes;
var regularProp = 'regular';
exports.regularProp = regularProp;
var errorProp = 'error';
exports.errorProp = errorProp;
var readOnlyProp = 'readOnly';
exports.readOnlyProp = readOnlyProp;
var disabledProp = 'disabled';
exports.disabledProp = disabledProp;
var defaultPillIconSize = '16';
exports.defaultPillIconSize = defaultPillIconSize;